import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper/bundle'; // import Swiper JS ALL

/*
 * Common
*/

// Single
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  /*
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  */
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    }
  }
});


// Hero
// Swiper のランダム化とフェード設定を追加
document.addEventListener('DOMContentLoaded', () => {
  // ユニークなセレクターでSwiperのwrapper要素を取得
  const swiperWrapper = document.querySelector('.hero-swiper .swiper-wrapper');
  const slides = Array.from(swiperWrapper.children);

  // ランダムな開始位置を決定
  const randomStartIndex = Math.floor(Math.random() * slides.length);

  // Swiper の初期化
  const heroSwiper = new Swiper('.hero-swiper', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000, // 3秒ごとにスライド
      disableOnInteraction: false, // ユーザー操作で停止しない
    },
    speed: 1000, // フェード速度
    initialSlide: randomStartIndex, // ランダムな開始位置を指定

    // スライドが変更されたときにトリガー
    on: {
      slideChangeTransitionStart: function () {
        // 768px以下かを判定
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          // すべての画像のtransformをリセット
          const images = document.querySelectorAll('.card-background');
          images.forEach((img) => {
            img.style.transition = 'none'; // アニメーションを一旦リセット
            img.style.transform = 'translateX(150px)'; // 開始位置
          });

          // 現在のスライドの画像をアニメーション
          const activeSlide = this.slides[this.activeIndex];
          const activeImage = activeSlide.querySelector('.card-background');
          if (activeImage) {
            setTimeout(() => {
              activeImage.style.transition = 'transform 5s linear'; // アニメーション設定
              activeImage.style.transform = 'translateX(-150px)'; // 終了位置
            }, 0); // リセット後に少し遅延を入れる
          }
        }
      },
    },
  });
});


// Home - Line-up
document.addEventListener('DOMContentLoaded', () => {
  const lineupSwiper = new Swiper('.lineup-swiper', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 1000,
    observer: true,
    observeParents: true,
    on: {
      init: () => {
        document.querySelector('.lineup-swiper').classList.add('swiper-initialized');
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', () => {
  let destroyMobileSwiper = null;

  const initializedestroyMobileSwiper = () => {
    const windowWidth = window.innerWidth;

    // 768px以上の場合にSwiperを有効化
    if (windowWidth > 991.98) {
      if (!destroyMobileSwiper) {
        destroyMobileSwiper = new Swiper('.lineup-destroy-mobile-swiper', {
          loop: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          speed: 1000,
          observer: true,
          observeParents: true,
        });
      }
    } else {
      // 768px以下の場合はSwiperを破棄
      if (destroyMobileSwiper) {
        destroyMobileSwiper.destroy(true, true);
        destroyMobileSwiper = null;
      }
    }
  };

  // 初期化実行
  initializedestroyMobileSwiper();

  // ウィンドウのリサイズ時にSwiperの有効化/無効化を切り替える
  window.addEventListener('resize', initializedestroyMobileSwiper);
});



/*
 * Home Header
 */
(function () {
  // トップページでのみ実行
  if (window.location.pathname !== "/") return;

  // 対象の固定ヘッダーを取得
  const fh = document.getElementById('header');
  if (!fh) return;

  // ビューポートの高さを取得
  const viewportHeight = window.innerHeight;

  // ダミー要素を作成して高さを監視
  const sentinel = document.createElement('div');
  sentinel.style.height = `${viewportHeight}px`;
  sentinel.style.width = "1px";
  sentinel.style.position = "absolute";
  sentinel.style.top = "0";
  document.body.insertBefore(sentinel, document.body.firstChild);

  // IntersectionObserverの設定
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        fh.classList.add('is-show');
      } else {
        fh.classList.remove('is-show');
      }
    },
    {
      rootMargin: "0px",
      threshold: 0,
    }
  );

  // 監視を開始
  observer.observe(sentinel);
})();



/* Recruit */
document.addEventListener("DOMContentLoaded", function () {
  // トグルボタンを取得
  const toggleButtons = document.querySelectorAll('.toggle-details-btn');

  toggleButtons.forEach((button) => {
    // 初期状態を設定
    const parent = button.closest('.post-recruit');
    if (parent) {
      const details = parent.querySelector('details');
      if (details) {
        if (details.open) {
          button.classList.add('is-open');
          button.classList.remove('is-closed');
          button.textContent = '閉じる'; // 初期文言
        } else {
          button.classList.add('is-closed');
          button.classList.remove('is-open');
          button.textContent = 'もっと見る'; // 初期文言
        }
      }
    }

    // ボタンをクリックしたときの処理
    button.addEventListener('click', () => {
      if (parent) {
        const details = parent.querySelector('details');
        if (details) {
          // open属性をトグル
          const isOpen = !details.open;
          details.open = isOpen;

          // ボタンのクラスと文言を更新
          if (isOpen) {
            button.classList.add('is-open');
            button.classList.remove('is-closed');
            button.textContent = '閉じる'; // 開いた時の文言
          } else {
            button.classList.remove('is-open');
            button.classList.add('is-closed');
            button.textContent = 'もっと見る'; // 閉じた時の文言
          }
        }
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // .click-close-parent クラスを持つ要素を取得
  const closeButtons = document.querySelectorAll(".click-close-parent");

  closeButtons.forEach(button => {
    button.addEventListener("click", function () {
      // 親要素を非表示にする
      const parent = this.parentElement;
      if (parent) {
        // parent.style.display = "none";
        parent.classList.add("hidden");
      }
    });
  });
});


// Franchise - Mobile
document.addEventListener("scroll", function () {
  const fixedElement = document.querySelector(".cta-request"); // 固定要素
  const requestSection = document.getElementById("request"); // 指定位置 (#request)

  if (!fixedElement || !requestSection) return;

  // #request セクションの位置を取得
  const requestPosition = requestSection.getBoundingClientRect().top;

  // #requestが画面内に入り始めたら非表示にする
  if (requestPosition <= window.innerHeight && requestPosition > 0) {
    fixedElement.classList.add("hide-cta");
  } else if (requestPosition > window.innerHeight) {
    // 再び#requestより上に戻ったら表示する
    fixedElement.classList.remove("hide-cta");
  }
});


// Franchise - Mobile Image Light
const target = document.querySelector("#mb-shopimage");
const child = document.querySelector("#mb-shopimage > img.light");

let isMaxOpacityReached = false; // 透明度が1に達したかどうかを追跡
let lastScrollY = window.scrollY; // 最後のスクロール位置を記録

window.addEventListener("scroll", () => {
  if (isMaxOpacityReached && window.scrollY > lastScrollY) return; // 下にスクロールしている場合は処理をスキップ

  const targetRect = target.getBoundingClientRect(); // 要素の位置情報を取得
  const windowHeight = window.innerHeight; // ウィンドウの高さ

  // 要素の中心点が画面内に入ったかチェック
  const elementCenter = targetRect.top + targetRect.height / 2;

  // 要素の中心点が画面中央からどれだけ離れているか計算
  const distanceFromCenter = Math.abs(windowHeight / 2 - elementCenter);

  // スクロール距離に応じて透明度の変化量を調整
  const maxDistance = windowHeight / 2; // 最大距離（画面中央の範囲）
  let opacity = Math.max(0, 1 - (distanceFromCenter / maxDistance) * 2); // 透明度の変化を強調する

  // targetが画面中央に近づいたら透明度を強制的に1にする
  if (distanceFromCenter < 20) { // 中央付近なら強制的に透明度1に
    opacity = 1;
    isMaxOpacityReached = true; // 透明度が1になったら追跡フラグを立てる
  }

  // もし透明度が1に近い（0.99以上）なら、確実に1に設定
  if (opacity >= 0.99) {
    opacity = 1;
    isMaxOpacityReached = true; // 透明度が1になったら追跡フラグを立てる
  }

  // 上にスクロールした場合、透明度を減少させる
  if (window.scrollY < lastScrollY) {
    isMaxOpacityReached = false; // 上にスクロールした場合、透明度をリセット
  }

  // 子要素の透明度を設定
  child.style.opacity = opacity;

  // 最後のスクロール位置を更新
  lastScrollY = window.scrollY;
});
